export default {"src":"/_next/static/media/Eyeball.22bbb3e3.svg","height":37,"width":41,"blurWidth":0,"blurHeight":0};